import type { PropsWithChildren } from "react";
import type { BoxProps } from "@mui/material/Box";
import type { WithSlots } from "types";
import { MultiFilePreview } from "lib/upload";
import { DownloadableAction, UseDownloadable } from "ui/molecules/Action";

type Props = WithSlots<
    & UseDownloadable
    & {
        readonly file: File | string;
        readonly sx?: BoxProps['sx'];
    }
>;

const DownloadFile = ({ sx, file, children, downloadFile }: PropsWithChildren<Props>) => (
    <DownloadableAction
        sx={{
            borderRadius: 1,
            width: 'auto',
            height: 'auto',
            textTransform: 'none',
            justifyContent: 'space-between',
            py: 0,
            gap: 1,
            ...sx
        }}
        file={file}
        downloadFile={downloadFile}
    >
        <MultiFilePreview
            files={[
                file
            ]}
        />
        {children}
    </DownloadableAction>
);

export default DownloadFile;
